<template>
  <div>
    <div class="col-md-12 m-0 p-0" v-if="!loading">
      <div class="col-12 col-md-12 m-auto m-0 p-0">
        <div class="col-12 m-0 p-0">
          <div class="col-md-12 m-0 p-0 my-2">
            <div>
              <h5 class="m-0 p-0"><strong>Payment Retrieval</strong></h5>
              <p class="m-0 p-0" v-if="paymentRetrievalOverview">
                {{ paymentRetrievalOverview.count || 0 }} items found
              </p>
            </div>
            <div
              class="payment-details row m-0 p-0 my-2 col-md-12"
            >
              <div class="col-md-2 ml-0 pl-0 text-center">
                <div
                  class="card border-0 py-3"
                  v-b-tooltip.hover
                  :title="paymentRetrievalOverview.total"
                  style="background: #5ba8ff; color: white"
                >
                  <p class="m-0 p-0">Total Amount</p>
                  <h2>{{ paymentRetrievalOverview.total | formatNumber }}</h2>
                </div>
              </div>
              <div class="col-md-2 text-center">
                <div
                  class="card border-0 py-3"
                  v-b-tooltip.hover
                  :title="paymentRetrievalOverview.balance"
                  style="background: #43dcbd; color: white"
                >
                  <p class="m-0 p-0">Balance Amount</p>
                  <h2>{{ paymentRetrievalOverview.balance | formatNumber }}</h2>
                </div>
              </div>
              <div class="col-md-2 text-center">
                <div
                  class="card border-0 py-3"
                  v-b-tooltip.hover
                  :title="paymentRetrievalOverview.waivedOff"
                  style="background: #ffc167; color: white"
                >
                  <p class="m-0 p-0">Waived Off</p>
                  <h2>
                    {{ paymentRetrievalOverview.waivedOff | formatNumber }}
                  </h2>
                </div>
              </div>
              <div class="col-md-2 text-center">
                <div
                  class="card border-0 py-3"
                  v-b-tooltip.hover
                  :title="
                    paymentRetrievalOverview.total -
                    (paymentRetrievalOverview.balance +
                      paymentRetrievalOverview.waivedOff)
                  "
                  style="background: #ff6780; color: white"
                >
                  <p class="m-0 p-0">Paid Amount</p>
                  <h2>
                    {{
                      (paymentRetrievalOverview.total -
                        (paymentRetrievalOverview.balance +
                          paymentRetrievalOverview.waivedOff))
                        | formatNumber
                    }}
                  </h2>
                </div>
              </div>
            </div>
            <!-- <b-button
              variant="light"
              class="border"
              @click="
                generatePaymentTicketToggler = !generatePaymentTicketToggler
              "
              size="sm"
              >Create Ticket</b-button
            > -->
          </div>
          <div class="col-md-12 row my-3">
            <div class="col-md-3 col-6 m-0 p-0">
              <input
                type="text"
                placeholder="search customer name or booking ID"
                v-model="search"
                class="form-control"
              />
            </div>
            <div class="col-4 col-md-4">
              <b-form-select
                v-model="currentStatus"
                :options="options"
              ></b-form-select>
            </div>
          </div>
          <div class="col-md-12 d-flex m-0 p-0">
            <div>
              <b-pagination
                v-model="currentPage"
                :total-rows="paymentRetrievalOverview.count"
                :per-page="perPage"
                aria-controls="my-table"
              ></b-pagination>
              <p class="m-0 p-0" style="font-size: 12px; color: gray">
                Loaded {{perPage}} items {{(currentPage - 1) * perPage}} - {{Number(((currentPage - 1) * Number(perPage))) + Number(perPage)}} of {{paymentRetrievalOverview.count}} items.
              </p>
            </div>
            <div class="ml-2">
              <b-form-select v-model="perPage">
                <b-select-option value="null" disabled>Limit</b-select-option>
                <b-select-option value="10">10</b-select-option>
                <b-select-option value="20">20</b-select-option>
                <b-select-option value="50">50</b-select-option>
                <b-select-option value="70">70</b-select-option>
                <b-select-option :value="paymentRetrievalOverview.count">All</b-select-option>
              </b-form-select>
            </div>
          </div>
          <div class="col-12 col-md-12 m-0 p-0">
            <b-table
              id="my-table"
              style="cursor: pointer"
              sticky-header
              :items="searchFilter"
              :fields="fields"
              responsive
              :busy="loadingTable"
            >
              <template #cell(customerData)="data">
                <b
                  @click="
                    $router.push(
                      'userProfile/' +
                        data.item.customerData.id +
                        '/' +
                        data.item.customerData.mobile
                    )
                  "
                  v-b-popover.hover="{
                    title: data.value,
                    content: ` 
                    <strong>Full Name:</strong><br> ${data.value} ${
                      data.item.customerData.lName
                    }
                    <br><strong>Mobile:</strong><br>
                    <a href='tel:${data.item.customerData.mobile}'>
                        ${data.item.customerData.mobile}
                    </a> 
                    <br><strong>Status:</strong><br> ${
                      data.item.customerData.status === 0
                        ? 'Inactive'
                        : 'Active'
                    }
                    <br><strong>Penalty Charge:</strong><br> Rs ${
                      data.item.customerData.penaltyCharge
                    }
                    `,
                    html: true,
                  }"
                  variant="success"
                >
                  {{ data.value }}
                </b>
              </template>
              <template #cell(customerData.mobile)="data">
              <a href='tel:${data.value}'>
                {{data.value}}
              </a>
              </template>
              <template #cell(bookingData)="data">
                <b
                  v-b-popover.hover="{
                    title: `Booking Details #${data.value}`,
                    content: ` 
                  <strong>Start Date: </strong><br> ${data.item.bookingData.startDate}
                  <br>
                  <strong>End Date: </strong>
                  <br> ${data.item.bookingData.endDate}
                  `,
                    html: true,
                  }"
                  variant="success"
                >
                  {{ data.value }}
                </b>
              </template>
              <template #cell(balance)="data">
                <b
                  v-b-popover.hover="{
                    title: `Amount Details`,
                    content: ` 
                    <strong>Amount:</strong><br> ${data.item.amount}
                  <br><strong>Waived off:</strong><br> ${data.item.waivedOff}
                  <br><strong>Balance:</strong><br> ${data.item.waivedOff}
                  `,
                    html: true,
                  }"
                  variant="success"
                >
                  ₹ {{ data.value }}
                </b>
              </template>
              <template #cell(status)="data">
                <b
                  v-b-popover.hover="{
                    title: data.value,
                    content: ` 
                    <strong>Paid On:</strong><br> ${data.item.paidOn}<br>
                    <strong>Partial Allowed:</strong><br> ${
                      data.item.allowPartial ? 'Yes' : 'No'
                    }
                  `,
                    html: true,
                  }"
                  variant="success"
                >
                  <span v-if="data.value === 'Due'" class="badge badge-danger">{{ data.value }}</span>
                  <span v-if="data.value === 'Paid'" class="badge badge-success">{{ data.value }}</span>
                </b>
              </template>
              <template #cell(comment)="data">
                <div class="ellipsis">
                  <b
                    class=""
                    v-b-popover.hover="{
                      title: 'More details',
                      content: ` 
                    <strong>Comment</strong>: <br> ${data.value} <br>
                    <strong>Address:</strong> <br> ${data.item.address}
                  `,
                      html: true,
                    }"
                    variant="success"
                  >
                    {{ data.value }}
                  </b>
                </div>
              </template>
              <template #cell(id)="data">
                <div>
                  <b-button variant="light" class="border" @click="adjustPayment(data.value)">Adjust</b-button>
                </div>
              </template>
              <template #table-busy>
                <div class="text-center text-danger my-5">
                  <b-spinner class="align-middle"></b-spinner>
                  <p class="my-3"><strong>We are Loading...</strong></p>
                </div>
              </template>
            </b-table>
          </div>
          <div class="col-md-12 m-0 p-0" v-if="searchFilter.length == 0">
              <p>No data found..</p>
            </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="col-5 m-0 p-0 my-3">
        <b-skeleton class="border-0" width="85%"></b-skeleton>
        <b-skeleton class="border-0" width="45%"></b-skeleton>
      </div>
      <b-row cols="6">
        <b-col>
          <b-skeleton-img></b-skeleton-img>
        </b-col>
        <b-col>
          <b-skeleton-img></b-skeleton-img>
        </b-col>
        <b-col>
          <b-skeleton-img></b-skeleton-img>
        </b-col>
        <b-col>
          <b-skeleton-img></b-skeleton-img>
        </b-col>
      </b-row>
      <div class="col-12 m-0 p-0 my-5">
        <b-skeleton class="border-0" width="60%"></b-skeleton>
        <b-skeleton class="border-0" width="15%"></b-skeleton>
        <b-skeleton class="border-0" width="28%"></b-skeleton>
        <b-skeleton class="border-0" width="88%"></b-skeleton>
      </div>
      <div class="col-12 my-4 m-0 p-0">
        <b-skeleton class="border-0 mb-5" width="28%"></b-skeleton>
        <b-skeleton-table
        class=""
        :rows="10"
        :columns="4"
        :table-props="{ bordered: false, striped: true }"
      ></b-skeleton-table>
      </div>
    </div>
    <b-modal
      scrollable
      hide-footer
      title="Create Payment Ticket"
      centered
      v-model="generatePaymentTicketToggler"
    >
      <div class="row col-md-12 col-12 m-0 p-0">
        <div v-if="!obj.bookingId">
          <!-- <p class="m-0 p-0">Enter Booking ID</p> -->
          <b-input-group class="mt-3">
            <template #prepend>
              <!-- <b-select v-model="searchMode" text="Dropdown" variant="info">
                <b-select-option value="bookingId">Booking ID</b-select-option>
                <b-select-option disabled value="vehicleId">Vehicle ID</b-select-option>
            </b-select> -->
            </template>
            <template #append>
              <b-button style="box-shadow: none" @click="searchBooking"
                >Search</b-button
              >
            </template>
            <b-form-input
              @keyup.enter="searchBooking"
              autofocus
              v-model="inputBookingId"
            ></b-form-input>
          </b-input-group>
          <div class="my-2">
            <b-alert
              :show="dismissCountDown"
              dismissible
              variant="warning"
              @dismissed="dismissCountDown = 0"
              >No booking found with this ID
            </b-alert>
          </div>
        </div>
        <div v-if="obj.bookingId">
          <div class="my-2">
            <b-alert show variant="success"
              >Selected Booking #{{ obj.bookingId }}
              <b-button variant="light" class="border" @click="resetBooking"
                >Reset ID</b-button
              >
            </b-alert>
          </div>
          <div class="mb-3 col-md-6 m-0 p-2">
            <p class="labels m-0 p-0">Amount</p>
            <input type="number" class="form-control" v-model="obj.amount" />
          </div>
          <div class="mb-3 col-md-12 m-0 p-2">
            <p class="labels m-0 p-0">Address</p>
            <textarea type="text" class="form-control" v-model="obj.address" />
          </div>
          <div class="mb-3 col-md-12 m-0 p-2">
            <p class="labels m-0 p-0">Comment</p>
            <textarea type="text" class="form-control" v-model="obj.comment" />
          </div>
          <div class="col-12 m-0 p-2">
            <div>
              <b-form-checkbox
                v-model="obj.allowPartial"
                name="check-button"
                switch
              >
                Allow Partial Payment
              </b-form-checkbox>
            </div>
          </div>
          <div class="text-right col-12 m-0 p-0">
            <b-button
              @click="createTicket"
              :disabled="invalid"
              variant="light"
              class="border"
              >Create Ticket</b-button
            >
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      loadingTable: true,
      currentPage: 1,
      perPage: 10,
      searchMode: "bookingId",
      search: "",
      currentStatus: "all",
      paymentType: "Cash",
      paidAmount: 0,
      options: [
        { value: "all", text: "View all" },
        { value: 1, text: "Due" },
        { value: 0, text: "Paid" },
      ],
      generatePaymentTicketToggler: false,
      obj: {
        bookingId: "",
        amount: 0,
        allowPartial: false,
        address: null,
        comment: null,
      },
      fields: [
        {
          key: "customerData",
          sortable: true,
          label: "Customer",
          formatter: (value) => {
            return value.fName;
          },
        },
        {
          key: "customerData.mobile",
          label: "Mobile"
        },
        {
          key: "bookingData",
          sortable: true,
          label: "Booking",
          formatter: (value) => {
            return value.bookingId;
          },
        },
        {
          key: "balance",
          sortable: true,
          label: "Balance",
        },
        {
          key: "status",
          sortable: true,
          label: "Payment Status",
          formatter: (value) => {
            return value === 0 ? "Paid" : "Due";
          },
        },

        {
          key: "createdAt",
          label: "Created",
          sortable: true,
          formatter: (value) => {
            return moment(value).format("DD-MM-YYYY");
          },
        },
        {
          key: "comment",
          label: "Comment",
        },
        {
          key: "id",
          label: "Action",
        },
      ],
      inputBookingId: "",
      dismissSecs: 5,
      dismissCountDown: 0,
      adjustPaymentToggler: false,
      editTicketId: "",
    };
  },
  props: {},
  created() {
    this.fetchData();
    this.fetchOverview()
  },
  // watch : {
  //   bookingId (value) {
  //     this.obj.bookingId = value
  //   }
  // },
  watch: {
    currentPage () {
      this.fetchData()
    },
    perPage () {
      this.fetchData()
    }
  },
  methods: {
    adjustPayment(value) {
      this.$router.push("/customers/payment/retrieval/view/" + value);
      // console.log(value);
      // this.adjustPaymentToggler = true;
      // this.editTicketId = value;
    },
    resetBooking() {
      this.obj.bookingId = "";
      this.inputBookingId = "";
    },
    fetchData() {
      this.loadingTable = true
      this.$store.dispatch("getPaymentTickets", {
        params : {
          limit: this.perPage,
          offset: (this.currentPage - 1) * this.perPage
        }
      }).then (()=> {
        this.loadingTable = false
      })
    },
    fetchOverview () {
      this.$store.dispatch("getTicketsOverview");
    },
    searchBooking() {
      if (this.searchMode == "bookingId") {
        this.$store
          .dispatch("getBookingByQuery", {
            bookingId: this.inputBookingId,
          })
          .then((x) => {
            this.inputBookingId = "";
            this.obj.bookingId = x[0].id;
            this.selectedBooking = x[0];
          })
          .catch(() => {
            this.obj.bookingId = "";
            this.dismissCountDown = this.dismissSecs;
          });
      } else if (this.searchMode == "vehicleId") {
        this.$store.dispatch("getBookingByVehicleId", {
          bookingId: this.inputBookingId,
        });
      } else {
        alert("Select Search Mode");
      }
    },
    createTicket() {
      console.log(this.obj);
      this.$store
        .dispatch("createPaymentTickets", this.obj)
        .then(() => {
          this.generatePaymentTicketToggler = false;
          this.fetchData();
          this.fetchOverview()
        })
        .catch(() => {
          alert("error");
        });
    },
  },
  computed: {
    loading() {
      return this.$store.state.loading_api;
    },
    paymentRetrievalHistory() {
      return this.$store.state.paymentRetrievalHistory;
    },
    paymentRetrievalOverview() {
      return this.$store.state.paymentRetrievalOverview;
    },
    fitered() {
      if (this.currentStatus == "all") {
        return this.paymentRetrievalHistory;
      } else {
        return this.paymentRetrievalHistory.filter((x) => {
          return x.status == this.currentStatus;
        });
      }
    },
    searchFilter() {
      return this.fitered.filter((post) => {
        return (
          post.customerData.fName
            .toLowerCase()
            .includes(this.search.toLowerCase()) ||
          post.bookingData.bookingId
            .toString()
            .includes(this.search.toLowerCase())
        );
      });
    },
  },
};
</script>

<style scoped>
.label {
  font-size: 12px;
  color: gray;
}
.ellipsis {
  white-space: nowrap;
  width: 250px !important;
  overflow: hidden;
  text-overflow: ellipsis;
}
::-webkit-scrollbar {
  display: none;
}
</style>